"use client";

import { useState } from "react";
import PhoneCodeLoginForm from "@/components/auth/PhoneCodeLoginForm";
import PhonePasswordLoginForm from "@/components/auth/PhonePasswordLoginForm";
import type { PhoneCodeLoginAccent } from "@/components/auth/PhoneCodeLoginForm";
import type { AuthPortal } from "@/lib/portalTokens";

type LoginMethod = "sms" | "password";

export type LoginMethodTabsProps = {
  accent: PhoneCodeLoginAccent;
  portal: AuthPortal;
  forgotPasswordHref: string;
  onSmsLogin: (mobile: string, code: string) => Promise<void>;
  onPasswordLogin: (mobile: string, password: string) => Promise<void>;
};

const tabStyles: Record<PhoneCodeLoginAccent, { active: string; inactive: string }> = {
  indigo: {
    active: "border-indigo-600 text-indigo-700",
    inactive: "border-transparent text-gray-500 hover:text-gray-700",
  },
  green: {
    active: "border-green-600 text-green-700",
    inactive: "border-transparent text-gray-500 hover:text-gray-700",
  },
  blue: {
    active: "border-blue-600 text-blue-700",
    inactive: "border-transparent text-gray-500 hover:text-gray-700",
  },
};

export default function LoginMethodTabs({
  accent,
  portal,
  forgotPasswordHref,
  onSmsLogin,
  onPasswordLogin,
}: LoginMethodTabsProps) {
  const [method, setMethod] = useState<LoginMethod>("password");
  const styles = tabStyles[accent];

  return (
    <div className="w-full max-w-md">
      <div className="mb-6 flex border-b border-gray-200">
        <button
          type="button"
          onClick={() => setMethod("sms")}
          className={`flex-1 border-b-2 px-4 py-2 text-sm font-medium transition-colors ${
            method === "sms" ? styles.active : styles.inactive
          }`}
        >
          验证码登录
        </button>
        <button
          type="button"
          onClick={() => setMethod("password")}
          className={`flex-1 border-b-2 px-4 py-2 text-sm font-medium transition-colors ${
            method === "password" ? styles.active : styles.inactive
          }`}
        >
          密码登录
        </button>
      </div>

      {method === "sms" ? (
        <PhoneCodeLoginForm accent={accent} onLogin={onSmsLogin} />
      ) : (
        <PhonePasswordLoginForm
          accent={accent}
          portal={portal}
          forgotPasswordHref={forgotPasswordHref}
          onLogin={onPasswordLogin}
        />
      )}
    </div>
  );
}
